import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import logo from '../../assets/logo.png';
import { message } from 'antd';
import { authService } from '../../services/authService';



export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const login = e.target.login.value;
    const senha = e.target.senha.value;

    try {
      const user = await authService.login(login, senha);
    //console.log('Usuário logado:', user);
      
      // Redirecionamento por tipo de usuário
      if (user.USU_TIPO === 'ADM') {
        navigate('/adm/dashboard', { replace: true });
      } else if (user.USU_TIPO === 'PREFEITURA') {
        navigate('/prefeitura/home', { replace: true });
      } else if (user.USU_TIPO === 'FORNECEDOR') {
        navigate('/fornecedor/home', { replace: true });
      }
    } catch (error) {
     // console.error('Erro no login:', error);
      
      // Exibir mensagem de erro da API
      const errorData = error.response?.data;
      
      if (errorData?.erros) {
        // Formato de erro de validação (ex: login não existe)
        const primeiroErro = Object.values(errorData.erros)[0];
        message.error({
          content: Array.isArray(primeiroErro) ? primeiroErro[0] : primeiroErro,
          duration: 6,
          style: { fontSize: '1.2rem' }
        });
      } else if (errorData?.message) {
        // Formato de erro de autenticação (ex: senha incorreta)
        message.error({
          content: errorData.message,
          duration: 6,
          style: { fontSize: '1.2rem' }
        });
      } else {
        message.error({
          content: 'Erro ao fazer login. Tente novamente.',
          duration: 6,
          style: { fontSize: '1.2rem' }
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-container">
      <div className="login-left">
      </div>

      <div className="login-right">
        <div className="form-wrapper">
          <img src={logo} alt="Logo G2 Peças" className="logo-right" />
          <h1>G2 Peças</h1>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="login">Usuário</label>
              <input 
                type="text" 
                id="login"
                name="login"
                placeholder="Digite o seu usuário" 
                disabled={loading}
              />
            </div>

            <div className="form-group password-group">
              <label htmlFor="senha">Senha</label>
              <div className="password-input-wrapper">
                <input 
                  type={showPassword ? "text" : "password"} 
                  id="senha"
                  name="senha"
                  placeholder="Digite sua senha" 
                  disabled={loading}
                />
                <button 
                  type="button" 
                  className="toggle-password"
                  onClick={togglePasswordVisibility}
                  disabled={loading}
                >
                  {showPassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading}>
              {loading ? 'ENTRANDO...' : 'ENTRAR'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
